import { Link, Navigate, useParams } from 'react-router-dom';
import { isLegalDocId, legalDocs, legalIndex } from '../content/legal';

export default function Legal() {
  const { doc } = useParams<{ doc: string }>();
  if (!doc || !isLegalDocId(doc)) return <Navigate to="/" replace />;
  const page = legalDocs[doc];

  return (
    <section className="section">
      <div className="shell" style={{ display: 'grid', gap: 48, alignItems: 'start' }}>
        <div className="legal-grid">
          <article className="legal-article measure-legal" data-component="legal-article">
            <p className="type-overline text-primary-ink">{page.nav}</p>
            <h1 className="mt-4 type-display-lg text-ink">{page.title}</h1>
            <p className="mt-3 type-label-sm text-ink-muted">
              {legalIndex.updatedLabel}：{page.updated}
            </p>

            <div className="notice-block mt-6" data-component="notice-block">
              <p className="type-label-md">{legalIndex.draftNote}</p>
            </div>

            <div className="mt-10">
              {page.sections.map((s) => (
                <section
                  key={s.id}
                  id={s.id}
                  className="legal-section-block"
                >
                  <h2 className="type-display-md text-ink">{s.title}</h2>
                  <div className="mt-4 stack-gap-4">
                    {s.body.map((p) => (
                      <p key={p} className="type-body-legal text-ink-secondary">{p}</p>
                    ))}
                  </div>
                </section>
              ))}
            </div>

            <p className="mt-10">
              <Link to="/" className="type-label-md link-plain">{legalIndex.backHome}</Link>
            </p>
          </article>

          <nav className="legal-toc" aria-label={legalIndex.onThisPage}>
            <p className="type-overline text-ink-muted">{legalIndex.onThisPage}</p>
            <ul className="mt-4 stack-gap-3" style={{ listStyle: 'none', padding: 0 }}>
              {page.sections.map((s) => (
                <li key={s.id}>
                  <a href={`#${s.id}`} className="type-label-sm text-ink-secondary">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </section>
  );
}
